// Complete Trip
export const COMPLETE_TRIP_REQUEST = "COMPLETE_TRIP_REQUEST";
export const COMPLETE_TRIP_SUCCESS = "COMPLETE_TRIP_SUCCESS";
export const COMPLETE_TRIP_FAILURE = "COMPLETE_TRIP_FAILURE";
export const RESET_COMPLETE_TRIP = "RESET_COMPLETE_TRIP";

interface CompleteTripPayload {
    cabid: any;
    bookingid: any;
    completedby: any;
    fare: any;
    mins: any;
    distance: any;
    piclat: any;
    piclon: any;
    present_location: any;
    feedback: any;
    iscredit: any;
}

export const completeTripRequest = (payload: CompleteTripPayload) => ({
    type: COMPLETE_TRIP_REQUEST,
    payload,
});

export const completeTripSuccess = (data: any) => ({
    type: COMPLETE_TRIP_SUCCESS,
    payload: data,
});

export const completeTripFailure = (error: any) => ({
    type: COMPLETE_TRIP_FAILURE,
    payload: error,
});

export const resetCompleteTrip = () => ({
    type: RESET_COMPLETE_TRIP,
});


// GET COMPLETE BOOKING BY DATE
export const GET_COMPLETE_BOOKING_BY_DATE_REQUEST = "GET_COMPLETE_BOOKING_BY_DATE_REQUEST";
export const GET_COMPLETE_BOOKING_BY_DATE_SUCCESS = "GET_COMPLETE_BOOKING_BY_DATE_SUCCESS";
export const GET_COMPLETE_BOOKING_BY_DATE_FAILURE = "GET_COMPLETE_BOOKING_BY_DATE_FAILURE";

export const getCompleteBookingByDateRequest = (
    branchid: string,
    fromdate: string,
    todate: string
) => ({
    type: GET_COMPLETE_BOOKING_BY_DATE_REQUEST,
    payload: { branchid, fromdate, todate },
});